import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { FollowUpItem } from "@/Patient/Models/MedicalSummary/FollowUpItem";

class FollowUpTableItemModel implements ITableDataSourceItem<FollowUpItem> {
    public Model: FollowUpItem;
    public Name: string;
    public IsSelected: boolean;
    public IsChecked: boolean;
    public itemId: number;

    constructor(model: FollowUpItem) {
        this.Model = model;
        this.itemId = sessionStore.newId();
        this.Name = model.getSpeciality();
    }
}

export { FollowUpTableItemModel };
